<template>
  <div class="mb-8">
    <div v-if="type === 'text'">
      <h2 v-if="row.title && row.title !== ''" class="mb-4">{{ row.title }}</h2>
      <div v-html="row.text"></div>
    </div>

    <div v-if="type === 'embed'" class="print:hidden">
      <div ref="wrap" v-html="row.embed" class="relative"></div>
    </div>

    <div v-if="type === 'gallery'">
      <div class="print:hidden">
        <carousel :per-page="1" :center-mode="true" :pagination-enabled="false" :navigation-enabled="true" navigation-next-label="›" navigation-prev-label="‹" @page-change="pageChange" class="font-thin">
          <slide v-for="(img, i) in row.images" :key="i" class="full-slide">
            <div class="absolute inset-0 flex items-center justify-start">
              <img :src="img.url" :width="img.width" :height="img.height" :alt="img.alt" class="object-contain w-full h-full object-center" loading="lazy"/>
            </div>
          </slide>
        </carousel>
        <div class="mt-2">
          <p class="text-thin">
            Bildergalerie: {{ page }}/{{ row.images.length }}
          </p>
        </div>
      </div>
      <div class="hidden print:block">
        <figure v-for="(img, i) in row.images" :key="i + '-pr'" class="w-full mb-6">
          <img :src="img.url" :width="img.width" :height="img.height" loading="lazy"/>
        </figure>
      </div>
    </div>

    <div v-if="type === 'columns'">
      <div class="flex flex-wrap">
        <div v-for="(col, i) in row.column" :key="i" class="w-full md:w-1/2 md:pr-4 lg:pr-8">
          <figure v-if="col.acf_fc_layout === 'image'">
            <img :src="col.image.sizes.medium_large" :alt="col.image.alt" loading="lazy" class=""/>
            <figcaption v-html="col.image.caption" class="font-light text-caption mt-2"></figcaption>
          </figure>
          <div v-else>
            <div v-html="col.text" class="text-quote font-thin"></div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="type === 'quote'">
      <div class="flex">
        <div class="hidden md:block w-1/3"></div>
        <div>
          <div v-html="row.text" class="text-quote font-thin"></div>
        </div>
      </div>
    </div>

    <div v-if="type === 'image'">
      <figure class="w-full">
        <img :src="row.image.sizes.medium_large" :alt="row.image.alt" loading="lazy" class="md:max-h-img" />
        <figcaption v-html="row.image.caption" class="font-light text-caption mt-2"></figcaption>
      </figure>
    </div>
  </div>
</template>

<script>
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    name: 'ContentRow',
    props: {
      row: Object
    },
    data () {
      return {
        page: 1
      }
    },
    computed: {
      type () {
        return this.row.acf_fc_layout || 'text'
      }
    },
    mounted () {
      const wrap = this.$refs.wrap

      if (!wrap) return

      const frame = wrap && wrap.firstElementChild
      if (!frame) return

      const width = frame.getAttribute('width')
      const height = frame.getAttribute('height')

      // already responsive? leave it be
      if (width && width.includes('%')) return

      const ratio = height / width

      frame.classList.add('absolute', 'w-full', 'h-full')
      wrap.style.paddingBottom = `${ratio * 100}%`
    },
    methods: {
      pageChange (n) {
        this.page = n + 1
      }
    },
    components: { Carousel, Slide }
  }
</script>

<style>
  .VueCarousel-navigation-prev,
  .VueCarousel-navigation-next {
    font-family: inherit !important;
    font-size: 2.4em;
    font-weight: 200;
    transform: translateY(-50%) !important;
  }
</style>
